import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Button, Skeleton } from 'antd';
import * as Action from '../../Actions/AoDActions';
import { getApiStatus } from '../../Reducers/ApiStatusReducer';
import { getQuoteRequestedByUser } from '../../Reducers/AoDReducer';
import AoDRequestQuoteSuccessModal from '../../Components/AoD/AoDRequestQuoteSuccessModal';
import InfoIconWithTooltip from '../../Components/Common/InfoIconWithTooltip/InfoIconWithTooltip';
import styles from './AoDAdvertisement.module.scss';
import jobMessage from '../../Components/JobForm/JobMessages';

const mapStateToProps = state => ({
  aodRequestQuoteApiStatus: getApiStatus(state, 'AoDRequestQuoteApiStatus'),
  quoteRequestedByUserApiStatus: getApiStatus(state, 'QuoteRequestedByUserApiStatus'),
  isQuoteRequestedByUser: getQuoteRequestedByUser(state),
});

const mapDispatchToProps = {
  requestQuote: Action.requestQuote,
  getIsQuoteRequestedByUser: Action.getIsQuoteRequestedByUser,
};

function AoDAdvertisement(props) {
  const {
    jobId,
    requestQuote,
    aodRequestQuoteApiStatus,
    isQuoteRequestedByUser,
    getIsQuoteRequestedByUser,
    quoteRequestedByUserApiStatus,
  } = props;
  const [isAoDModalVisible, setAodModalVisibility] = React.useState(false);

  React.useEffect(() => {
    getIsQuoteRequestedByUser();
  }, []);

  const onRequestQuote = async () => {
    const isSuccess = await requestQuote(jobId);
    if (isSuccess) setAodModalVisibility(true);
  };

  const onCloseModal = () => {
    setAodModalVisibility(false);
  };

  return (
    <Skeleton loading={quoteRequestedByUserApiStatus === 'INPROGRESS'}>
      <div className={styles.aodTitle}>
        <FormattedMessage {...jobMessage.applicantsOnDemandLabel} />
      </div>
      <div className={styles.aodContent}>
        <FormattedMessage {...jobMessage.automateHighVolumeSourcingLabel} />
        &nbsp;
        <span className={styles.highlightContent}>
          <FormattedMessage {...jobMessage.captureQualifiedLabel} />
        </span>
        ,&nbsp;
        <span className={styles.highlightContent}>
          <FormattedMessage {...jobMessage.engagedApplicantsLabel} />
        </span>
        &nbsp;
        <FormattedMessage {...jobMessage.payForPerformanceSolutionDescription} />
      </div>
      <Button
        type="primary"
        shape="round"
        style={{ marginTop: '5px' }}
        onClick={onRequestQuote}
        loading={aodRequestQuoteApiStatus === 'INPROGRESS'}
        disabled={isQuoteRequestedByUser}
      >
        <FormattedMessage {...jobMessage.requestQuoteLabel} />
      </Button>
      {isQuoteRequestedByUser ? (
        <span className={styles.infoTooltip}>
          <InfoIconWithTooltip tooltipTitle={<FormattedMessage {...jobMessage.requestReceivedMessage} />} />
        </span>
      ) : null}
      {isAoDModalVisible ? <AoDRequestQuoteSuccessModal onClose={onCloseModal} isVisible={isAoDModalVisible} /> : null}
    </Skeleton>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AoDAdvertisement);
export { AoDAdvertisement as AoDAdvertisementWithoutStore };
